import styled from "styled-components"
import { 
    // COLOR,
    // FONT
 } from 'assets'
 
export const GenreProfileContainerStyled = styled.div`
/*===============================================
 Container 
===============================================*/
    
/*===============================================
Theme 
===============================================*/
  
`